import { AlertModal } from "#components";

const overlay = useOverlay()
const modal = overlay.create(AlertModal)
interface ModalOptions {
    message: string,
    buttonAction?: () => void,
    buttonActionText?: string,
}
export function useGlobalModal() {
    function openModal(options: ModalOptions) {
        const result = modal.open(options).result;
        return result;
    }

    return {
        modal,
        openModal
    }
}